








import { Component, Vue } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import cDatagrid from '@/components/default/Datagrid.vue';

import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxStateStoring,
  DxSearchPanel,
} from 'devextreme-vue/data-grid';
import ActionPointsOverview from '../components/actionpointsTable.vue';

@Component({
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxStateStoring,
    DxSearchPanel,
    cCard,
    cDatagrid,
    ActionPointsOverview
  },
})
export default class ActionPointsOverviewPage extends Vue {

}
